import { render } from "./kubeovn.io.vpcnatgateway.vue?vue&type=template&id=d4b22aa2"
import script from "./kubeovn.io.vpcnatgateway.vue?vue&type=script&lang=js"
export * from "./kubeovn.io.vpcnatgateway.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__